module.exports = __webpack_public_path__ + "static/media/logoban.fed1be77.svg";